import React from 'react';
import { styled } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';
import Snackbar from '@mui/material/Snackbar';
import MuiSnackbarContent from '@mui/material/SnackbarContent';
import useRoomState from '../../hooks/useRoomState/useRoomState';

const SnackbarContent = styled(MuiSnackbarContent)({
  backgroundColor: '#6db1ff',
  display: 'flex',
  alignItems: 'center',
});

export default function ReconnectingNotification() {
  const roomState = useRoomState();

  return (
    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={roomState === 'reconnecting'}>
      <SnackbarContent
        message={
          <>
            <InfoIcon sx={{ marginRight: '0.8em' }} />
            Reconnecting&hellip;
          </>
        }
      />
    </Snackbar>
  );
}
